var AdTypes;
(function (AdTypes) {
    AdTypes["INTER"] = "INTER";
    AdTypes["REWARD"] = "REWARD";
    AdTypes["NATIVE"] = "NATIVE";
    AdTypes["NATIVE_SOON"] = "NATIVE_SOON";
    AdTypes["BANNER"] = "BANNER";
    AdTypes["MREC"] = "MREC";
    AdTypes["APPOPEN"] = "APPOPEN";
})(AdTypes || (AdTypes = {}));
export default AdTypes;
//# sourceMappingURL=AdTypes.js.map